export default "__VITE_PUBLIC_ASSET__01a3567d__"